import React from "react";
import footprint from "../assets/footprint-fill.png";
import { RiPinDistanceFill, RiFireLine } from "react-icons/ri";
import { IoFootsteps } from "react-icons/io5";

interface StatCardsProps {
  units: {
    steps: string;
    distance: string;
    caloriesburned: string;
  };
  summary?: {
    steps?: { avg: number; min: number; max: number };
    distance?: { avg: number; min: number; max: number };
    caloriesburned?: { avg: number; min: number; max: number };
  };
}

type MetricKey = "steps" | "distance" | "caloriesburned";

const ActivityStatCards: React.FC<StatCardsProps> = ({
  units,
  summary,
}) => {
  const primaryColor = "var(--svg-color, #094752)";
  const textColor = "var(--text-color, #333)";
  const cardBg = "var(--card-background, #fff)";
  const iconBg = "var(--icon-bg, #E0F7FA)";
  const iconText = "var(--menu-item-color)";

  const renderCard = (key: MetricKey, icon: React.ReactNode) => {
    const data = summary?.[key] || { avg: 0, min: 0, max: 0 };

    const formatVal = (num: number) =>
      Number.isInteger(num) ? num : parseFloat(num.toFixed(2));

    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px",
          borderRadius: "12px",
          backgroundColor: cardBg,
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
          border: "1px solid rgba(0,0,0,0.05)",
          minWidth: "200px",
          gap: "12px",
          color: textColor
        }}
      >
        {/* LEFT: Icon Circle */}
        <div style={{
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          backgroundColor: iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          border: `1px solid ${primaryColor}`
        }}>
          {icon}
        </div>

        {/* CENTER: Avg Value */}
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flex: 1,
          paddingRight: "12px",
          borderRight: "1px solid var(--border-color, #eee)"
        }}>
          <span style={{
            fontSize: "14px",
            fontWeight: "700",
            color: "var(--menu-item-color)",
            marginBottom: "4px",
            textTransform: "uppercase"
          }}>
            Avg
          </span>
          <span style={{ fontSize: "20px", fontWeight: "700", color: "var(--menu-item-color)" }}>
            {formatVal(data.avg)}
          </span>
        </div>

        {/* RIGHT: Max / Min */}
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          minWidth: "70px"
        }}>
          {/* Max Row */}
          <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: "11px", fontWeight: "700", color: "var(--menu-item-color)" }}>Max</span>
            <span style={{ fontSize: "14px", fontWeight: "600", color: textColor }}>
              {formatVal(data.max)}
            </span>
          </div>

          {/* Min Row */}
          <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: "11px", fontWeight: "700", color: "var(--menu-item-color)" }}>Min</span>
            <span style={{ fontSize: "14px", fontWeight: "600", color: textColor }}>
              {formatVal(data.min)}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ display: "flex", gap: "16px", marginBottom: "16px", width: "100%", flexDirection: "column" }}>

      {renderCard("steps",
        <IoFootsteps style={{ fontSize: "24px", color: primaryColor }} />
      )}

      {renderCard("distance",
        <RiPinDistanceFill style={{ fontSize: "24px", color: primaryColor }} />
      )}

      {renderCard("caloriesburned",
        <RiFireLine style={{ fontSize: "24px", color: primaryColor }} />
      )}

    </div>
  );
};

export default ActivityStatCards;